<script>
import {ArrowUpIcon,ArrowRightIcon} from 'vue-feather-icons';
import Navbar from "@/components/navbar";
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import axios from 'axios';

import AOS from 'aos';
import "aos/dist/aos.css";

export default {
  components: {
    Layout,
    Navbar,
    ArrowUpIcon,
    ArrowRightIcon
  },
  data() {
    return {
      appConfig: appConfig,
      map: null,
      geocoder: null,
      baseInfo: {},
      // 상담소 힘내
      features1: [
        {
          icon: "mdi mdi-phone-in-talk",
          title: "상담",
          subtext: "전화, 면접, 현장, 인터넷상담 등(비밀상담원칙)",
        },
        {
          icon: "mdi mdi-face-woman-shimmer-outline",
          title: "지원대상",
          subtext: "성매매 경험 여성, 성매매/성착취 피해자, 온라인을 매개로 한 성매매(조건만남) 경험 여성, 성착취 목적의 인신매매 피해자(내국인/외국인/이주여성)",
        },
        {
          icon: "mdi mdi-ambulance",
          title: "긴급구조",
          subtext: "현장출동을 통한 신변보호 및 긴급구조",
        },
        {
          icon: "mdi mdi-scale-balance",
          title: "법률지원",
          subtext: "법률상담, 고소장•진술서 작성, 경찰서•법원 동행, 민•형사소송 변호사 선임 파산면책•개인회생",
        },
        {
          icon: "mdi mdi-medical-bag",
          title: "의료지원",
          subtext: "성매매 관련 신체적•정신적 후유증 진료 및 동행, 성매매 관련 폭력 피해 의료비 지원",
        },
        {
          icon: "mdi mdi-hexagon-multiple",
          title: "프로그램",
          subtext: "전문가 심리상담, 문화체험 등",
        },
        {
          icon: "mdi mdi-google-translate",
          title: "외국인여성상담",
          subtext: "성매매/성착취 피해 상담 통번역 지원, 고소장•진술서 통번역 지원",
        },
        {
          icon: "mdi mdi-home-group",
          title: "홍보활동",
          subtext: "성매매업소 현장방문상담을 통한 정보제공 및 홍보•상담",
        },
      ],
      // 그룹홈
      features2: [
        {
          icon: "mdi mdi-home-assistant",
          title: "독립적인 주거지원",
          subtext: "안전한 신변보호, 주거 및 생활지원",
        },
        {
          icon: "mdi mdi-offer",
          title: "생활상담",
          subtext: "건강할 권리 찾는 의료지원(검진, 진료)",
        },
        {
          icon: "mdi mdi-sofa",
          title: "자활과 독립을 위한 다양한 정보제공",
          subtext: "민•형사 소송지원, 변호사 수임, 개인파산면책 등",
        },
      ],
      // 쉼터
      features3: [
        {
          icon: "mdi mdi-face-woman-shimmer-outline",
          title: "생활지원",
          subtext: "안전한 신변보호, 주거 및 생활지원",
        },
        {
          icon: "mdi mdi-medical-bag",
          title: "의료지원",
          subtext: "건강할 권리 찾는 의료지원(검진, 진료)",
        },
        {
          icon: "mdi mdi-scale-balance",
          title: "법률지원",
          subtext: "민•형사 소송지원, 변호사 수임, 개인파산면책 등",
        },
        {
          icon: "mdi mdi-school-outline",
          title: "직업교육",
          subtext: "진로상담, 학원 수강 및 실습지원, 검정고시 및 진학지원",
        },
        {
          icon: "mdi mdi-hexagon-multiple",
          title: "치료회복프로그램",
          subtext: "심리, 문화, 체험 등 정서적지원 프로그램",
        },
      ],
      // 자활지원센터
      features4: [
        {
          icon: "mdi mdi-school-outline",
          title: "취업진학 및 기술교육",
          subtext: ["취업•창업 또는 진학준비 등과 연관된 직업훈련비 지원", "교육 참여시 직업훈련수당 지원"]
        },
        {
          icon: "mdi mdi-television-ambient-light",
          title: "자활 및 사회통합지원",
          subtext: ["진로 관련 적성검사 및 직업상담", "사회, 경제, 심리적 자원 확장을 위한 자활교육"]
        },
        {
          icon: "mdi mdi-thumb-up-outline",
          title: "자활참여자 지원사업",
          subtext: ["함께 하는 삶을 위한 관계와 소통 훈련", "안정적인 자활사업참여를 위한 자활 참여자 지원금", "인턴십프로그램(외부업체와 협약 체결 후 직업체험)"]
        },
      ],
    }
  },
  computed: {
  },
  mounted() {
    // AOS 초기화
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  },
  created() {
    this.getWebSiteInfoBase()
  },
  metaInfo() {
    return {
      title: '부설기관 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터에서 운영중인 부설기관 - 상담소 힘내, 그룹홈, 쉼터, 자활지원센터'
        },
        {
          property: 'og:title',
          content: '부설기관 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터에서 운영중인 부설기관 - 상담소 힘내, 그룹홈, 쉼터, 자활지원센터'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '부설기관 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터에서 운영중인 부설기관 - 상담소 힘내, 그룹홈, 쉼터, 자활지원센터'
        }
      ]
    }
  },
  methods: {
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    secretWrite() {
      this.$router.push({ path: '/jy/5/w'})
      // 현재 이미지 인덱스를 증가시킴
      this.currentSeroIndex++;
      // 이미지 인덱스가 이미지 배열의 길이를 초과하면 처음 이미지로 돌아감
      if (this.currentSeroIndex >= this.seroImages.length) {
        this.currentSeroIndex = 0;
      }
    },
    scrollToDiv(val) {
      const element = document.getElementById(val);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
}
</script>

<template>
  <Layout>
    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar :nav-light="true" />

    <section class="bg-half-2 navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-5"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h3>
                  부설기관
                </h3>
                <h4>센터에서 운영중인 부설기관</h4>
              </div>
              <div class="page-next">
                <nav aria-label="breadcrumb" class="d-inline-block">
                  <ul class="breadcrumb bg-white rounded shadow mb-0">
                    <li class="breadcrumb-item">
                      <router-link to="/">홈</router-link>
                    </li>
                    <li class="breadcrumb-item "><a href="#">센터</a></li>
                    <li class="breadcrumb-item active" aria-current="page">부설기관</li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 둥글게 처리 -->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <section class="section bg-light mt-60 mb-0">

      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col--6 col-12">
            <div data-aos="fade-up" class="row mr-lg-4" id="counter">
              <div class="col-md-6 col-12">
                <div class="row">
                  <div @click="scrollToDiv('scroll1')" class="col-12 mt-4 mt-lg-0 pt-2 pt-lg-0 cursor-pointers">
                    <div class="card explore-feature border-0 rounded text-center bg-white shadow">
                      <div class="card-body">
                        <div class="icon rounded-circle shadow-lg d-inline-block">
                          <i class="mdi mdi-phone-ring h3 text-danger"></i>
                        </div>
                        <h4 class="mt-3 title text-danger">상담소 힘내</h4>
                        <p class="font-size-14 text-muted mb-0">전화, 면접, 현장, 인터넷 상담이 가능하며 현장출동을 통한
                          신변보호 및 긴급구조를 지원하고 있습니다. 그 외에 법률지원, 의료지원과 정서지원 프로그램을
                          운영하고 있습니다.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div @click="scrollToDiv('scroll2')" class="col-12 mt-4 pt-2 cursor-pointers">
                    <div class="card explore-feature border-0 rounded text-center bg-white shadow">
                      <div class="card-body">
                        <div class="icon rounded-circle shadow-lg d-inline-block">
                          <i class="mdi mdi-warehouse h3 text-success"></i>
                        </div>
                        <h4 class="mt-3 title text-success">그룹홈</h4>
                        <p class="font-size-14 text-muted mb-0">
                          그룹홈은 보다 가정에 유사한 대체안으로, 이용자의 사회적 자립을 위한 종합적인 지원이 가능한
                          주거생활형태중 하나이며, 생활상담, 자활과 독립을 위한 다양한 정보를 제공하고 있습니다.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-6 col-12 cursor-pointers">
                <div class="row pt-lg-4 mt-lg-4">
                  <div @click="scrollToDiv('scroll3')" class="col-12 mt-4 pt-2">
                    <div class="card explore-feature border-0 rounded text-center bg-white shadow">
                      <div class="card-body">
                        <div class="icon rounded-circle shadow-lg d-inline-block">
                          <i class="mdi mdi-umbrella h3 text-info"></i>
                        </div>
                        <h4 class="mt-3 title text-info">쉼터</h4>
                        <p class="font-size-14 text-muted mb-0">안전한 신변보호와 주거 및 생활지원을 돕고있으며, 검진, 진료 수술을 통한 의료지원과
                          변호사 수임, 민형사 소송의 법률지원, 진로상담 및 학원수강을 통한 직업교육을 실시하고 있습니다.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div @click="scrollToDiv('scroll4')" class="col-12 mt-4 pt-2 cursor-pointers">
                    <div class="card explore-feature border-0 rounded text-center bg-white shadow">
                      <div class="card-body">
                        <div class="icon rounded-circle shadow-lg d-inline-block">
                          <i class="mdi mdi-looks h3 text-blue"></i>
                        </div>
                        <h4 class="mt-3 title text-blue">자활지원센터</h4>
                        <p class="font-size-14 text-muted mb-0">자활지원센터는 취업과 창업 및 진학준비등과 연관된 직업훈련비를 지원하고 있으며,
                          함께하는 삶을 위한 관계와 소통훈련을 실시하고 있으며, 인턴쉽 프로그램이 마련되어 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col--6 col-12 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="section-title ml-lg-4">
              <p class="text-center">
                <img :src="`${appConfig.url}/images/_decen/logo/logo_old.png`" width="60" alt="">
              </p>
              <h4 class="text-center title text-primary mb-3">대구여성인권센터 부설기관</h4>
              <p class="text-muted">
                대구여성인권센터는 성매매 피해여성에게 다양한 지원을 하는 부설기관을 통해서
                상담, 법률, 의료, 생활, 교육, 자활지원 등의 여러 지원 사업을 체계적으로 관리 운영하고 있습니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="scroll1" class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <i class="mdi mdi-phone-ring h3 text-danger"></i>
              <h4 class="title text-danger mb-4">상담소 힘내</h4>
              <p class="text-muted para-desc mx-auto mb-0 font-size-15">
                전화, 면접, 현장, 인터넷 상담이 가능하며 현장출동을 통한 신변보호 및 긴급구조를 지원하고 있습니다. 
                그 외에 법률지원, 의료지원과 정서지원 프로그램을 운영하고 있습니다.
              </p>
              <div class="mt-2">
                <span @click="secretWrite()" class="btn btn-lg btn-danger cursor-pointers">비밀보장 상담하기</span>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" class="col-lg-3 col-md-4 mt-2 pt-2" v-for="(item, index) of features1" :key="index">
            <div class="card features fea-primary rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
              <span class="h1 icon2 text-danger">
                <i :class="`${item.icon}`"></i>
              </span>
              <div class="card-body p-0 content">
                <h5>{{ item.title }}</h5>
                <p class="para text-muted mb-0">{{ item.subtext }}</p>
              </div>
              <span class="big-icon text-center">
                <i :class="`${item.icon}`"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="scroll2" class="section bg-light mt-60 mb-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <i class="mdi mdi-warehouse h3 text-success"></i>
              <h4 class="title text-success mb-4">그룹홈</h4>
              <p class="text-muted para-desc mx-auto mb-0 font-size-15">
                그룹홈은 보다 가정에 유사한 대체안으로, 이용자의 사회적 자립을 위한 종합적인 지원이 가능한
                주거생활형태중 하나이며, 생활상담, 자활과 독립을 위한 다양한 정보를 제공하고 있습니다.
              </p>
            </div>
          </div>

          <div data-aos="fade-up" class="col-lg-4 col-md-4 mt-2 pt-2" v-for="(item, index) of features2" :key="index">
            <div class="features feature-clean course-feature text-center">
              <div class="image position-relative d-inline-block">
                <i :class="`${item.icon} h1 text-success`"></i>
              </div>

              <div class="content mt-4">
                <h5>{{item.title}}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="scroll3" class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <i class="mdi mdi-umbrella h3 text-info"></i>
              <h4 class="title text-info mb-4">쉼터</h4>
              <p class="text-muted para-desc mx-auto mb-0 font-size-15">
                안전한 신변보호와 주거 및 생활지원을 돕고있으며, 
                검진, 진료 수술을 통한 의료지원과 변호사 수임, 민형사 소송의 법률지원, 
                진로상담 및 학원수강을 통한 직업교육을 실시하고 있습니다.
              </p>
            </div>
          </div>

          <div data-aos="fade-up" class="col-lg-4 col-md-6 mt-4 pt-2" v-for="(item, index) of features3" :key="index">
            <div class="card border-0 features feature-clean course-feature p-4 overflow-hidden shadow">
              <div class="icons text-info text-center">
                <i class="d-block bg-soft-info rounded h3 mb-0" :class="`${item.icon}`"></i>
              </div>
              <div class="card-body p-0 mt-4">
                <h5 class="text-info">{{ item.title }}</h5>
                <p class="text-muted font-size-13 mt-2">
                  {{ item.subtext }}
                </p>
                <i class="text-right text-info full-img" :class="`${item.icon}`"></i>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>

    <section id="scroll4" class="section bg-light mt-60 mb-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <i class="mdi mdi-looks h3 text-blue"></i>
              <h4 class="title text-blue mb-4">자활지원센터</h4>
              <p class="text-muted para-desc mx-auto mb-0 font-size-15">
                자활지원센터는 취업과 창업 및 진학준비등과 연관된 직업훈련비를 지원하고 있으며, 
                함께하는 삶을 위한 관계와 소통훈련을 실시하고 있으며, 인턴쉽 프로그램이 마련되어 있습니다.
              </p>
            </div>
          </div>

          <div data-aos="fade-up" class="col-lg-4 col-md-4 mt-2 pt-2" v-for="(item, index) of features4" :key="index">
            <div class="features feature-clean course-feature text-center">
              <div class="image position-relative d-inline-block">
                <i :class="`${item.icon} h1 text-blue`"></i>
              </div>

              <div class="content mt-4">
                <h5>{{item.title}}</h5>
              </div>
              <div v-for="(i, ind) of item.subtext" :key="ind">
                <p class="para text-muted mb-0 font-size-13">{{ i }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>
